import React, { useContext } from "react";
import { AOS_ANIMATION, AOS_DELAY, DIRECTUS_SERVER } from "../../config";
import { FeaturesContext } from "../../contexts/FeaturesContext";
import { Headline } from "../Headline/Headline";
import { HTMLParser } from "../HTMLParser/HTMLParser";
import {
  Iconlist,
  IconlistContent,
  IconlistIcon,
  IconlistItem
} from "../Iconlist/Iconlist";

interface FeaturesListProps {}

export const FeaturesList: React.FC<FeaturesListProps> = () => {
  const featuresContext = useContext(FeaturesContext);
  const features = featuresContext.featureItems[0];

  if (features)
    return (
      <Iconlist>
        <IconlistItem>
          <IconlistIcon dataAos={AOS_ANIMATION}>
            <img
              src={DIRECTUS_SERVER + features.feature_1_icon.data.asset_url}
              alt="icon"
            />
          </IconlistIcon>
          <IconlistContent dataAos={AOS_ANIMATION} dataAosDelay={AOS_DELAY}>
            <Headline bold={features.feature_1_headline} />
            <div>
              <HTMLParser html={features.feature_1_text} />
            </div>
          </IconlistContent>
        </IconlistItem>
        <IconlistItem>
          <IconlistIcon dataAos={AOS_ANIMATION}>
            <img
              src={DIRECTUS_SERVER + features.feature_2_icon.data.asset_url}
              alt="icon"
            />
          </IconlistIcon>
          <IconlistContent dataAos={AOS_ANIMATION} dataAosDelay={AOS_DELAY}>
            <Headline bold={features.feature_2_headline} />
            <div>
              <HTMLParser html={features.feature_2_text} />
            </div>
          </IconlistContent>
        </IconlistItem>
      </Iconlist>
    );

  return <></>;
};
